// Who gets a message affordance for a media person, per the messaging policy in MessageButton.jsx:
// media people may message other media people, promoters may not message media at all, and nobody
// messages themselves. MessageButton itself cannot see the viewer/target relationship, so the gate
// lives here — shared by the media cards and the media profile show page's Connect card.
//
// Cosmetic only. The authoritative rule is Interact::MessagingEligibility, enforced server-side in
// the conversations/receivers controllers; this just hides the affordance.
import mayStartConversations from "../../my_inbox/mayStartConversations";

export function viewerIsMediaProfile() {
  return globalThis.Qwoted?.CURRENT_PROFILE_TYPE === "type_media";
}

export default function canMessageMediaProfile(hitId) {
  if (!viewerIsMediaProfile() || !mayStartConversations()) return false;

  return String(hitId) !== String(globalThis.Qwoted?.CURRENT_PROFILE_ID);
}
